import { Link } from "react-router-dom";

// Tropical sign name -> Learn article slug (category "signs")
const SIGN_ARTICLE_SLUG = {
  Aries: "aries-mesha",
  Taurus: "taurus-vrishabha",
  Gemini: "gemini-mithuna",
  Cancer: "cancer-karka",
  Leo: "leo-simha",
  Virgo: "virgo-kanya",
  Libra: "libra-tula",
  Scorpio: "scorpio-vrishchika",
  Sagittarius: "sagittarius-dhanu",
  Capricorn: "capricorn-makara",
  Aquarius: "aquarius-kumbha",
  Pisces: "pisces-meena",
};

/**
 * Prominent, illuminated Moon placement line with the tropical sign and sidereal
 * nakshatra linked to their Learn detail pages. All values are dynamic.
 */
export const MoonPlacement = ({ sign, nakshatra, nakshatraSlug, pada, className = "" }) => {
  if (!sign || !nakshatra || !pada) return null;

  const signSlug = SIGN_ARTICLE_SLUG[sign];
  const signTo = signSlug ? `/learn/article/${signSlug}` : null;
  const nakTo = nakshatraSlug ? `/nakshatras/${nakshatraSlug}` : null;

  const SignNode = signTo ? (
    <Link to={signTo} className="moon-placement-link" data-testid="moon-placement-sign-link" aria-label={`Learn about ${sign}`}>
      {sign}
    </Link>
  ) : (
    <span className="text-white">{sign}</span>
  );

  const NakNode = nakTo ? (
    <Link to={nakTo} className="moon-placement-link" data-testid="moon-placement-nakshatra-link" aria-label={`Learn about ${nakshatra}`}>
      {nakshatra}
    </Link>
  ) : (
    <span className="text-white">{nakshatra}</span>
  );

  return (
    <p
      className={`moon-placement text-white/85 text-lg sm:text-xl md:text-2xl font-light leading-relaxed tracking-wide ${className}`}
      data-testid="moon-placement"
    >
      The Moon is in {SignNode} in the tropical zodiac and {NakNode}, pada {pada}, in the sidereal nakshatra system.
    </p>
  );
};
